
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"2 2 20 20","fill":"none","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 15.5H9"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"9"}}),_c('path',{attrs:{"d":"M12 12.5v-5M10 9.5l2-2 2 2"}})])
          )
        }
      }
    